import { render, staticRenderFns } from "./CreateBusinessBook.vue?vue&type=template&id=98ccbe4a&"
import script from "./CreateBusinessBook.js?vue&type=script&lang=js&"
export * from "./CreateBusinessBook.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports